import { cn } from "@devhop/ui";
import { Medal, Trophy } from "lucide-react";

type Props = {
  rank: number;
  className?: string;
};

/** Top 3: Lucide icons (gold / silver / bronze); otherwise numeric rank. */
export function RankIcon({ rank, className }: Props) {
  if (rank === 1) {
    return (
      <span
        className={cn("inline-flex items-center justify-center", className)}
        title="1st place"
      >
        <Trophy className="size-6 text-amber-500" aria-hidden />
        <span className="sr-only">Rank 1</span>
      </span>
    );
  }
  if (rank === 2) {
    return (
      <span
        className={cn("inline-flex items-center justify-center", className)}
        title="2nd place"
      >
        <Medal className="size-6 text-slate-400" aria-hidden />
        <span className="sr-only">Rank 2</span>
      </span>
    );
  }
  if (rank === 3) {
    return (
      <span
        className={cn("inline-flex items-center justify-center", className)}
        title="3rd place"
      >
        <Medal
          className="size-6 text-amber-800 dark:text-amber-600"
          aria-hidden
        />
        <span className="sr-only">Rank 3</span>
      </span>
    );
  }
  return (
    <span className={cn("font-bold text-foreground tabular-nums", className)}>
      {rank}
    </span>
  );
}
